<template>
  <div>
  <a-dropdown v-if="currentUser && currentUser.username" placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <a-avatar size="small" src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png" class="antd-pro-global-header-index-avatar" />
      <span>{{ currentUser.username }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
        <a-menu-item v-if="menu" key="center" @click="handleToCenter">
          <a-icon type="lock" />
          {{ $t('修改密码') }}
        </a-menu-item>
       <!-- <a-menu-item v-if="menu" key="settings" @click="handleToSettings">
          <a-icon type="setting" />
          {{ $t('设置中心') }}
        </a-menu-item>
        <a-menu-divider v-if="menu" /> -->
        <a-menu-item key="logout" @click="handleLogout">
          <a-icon type="logout" />
          {{ $t('退出登录') }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small" :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
  
  
  <a-modal title="修改密码" style="top: 100px;" :width="500" v-model="passwordPaneVisible" @ok="changeOperatorPassword">
    <Form ref="passwordValidate" :model="passwordValidate" :rules="passwordRule" :label-width="80">
      <FormItem label="原密码" prop="password">
        <Input v-model="passwordValidate.password" placeholder="请输入原密码"></Input>
      </FormItem>
      <FormItem label="新密码" prop="newPassword">
        <Input v-model="passwordValidate.newPassword" placeholder="请输入密码"></Input>
      </FormItem>
    </Form>
  </a-modal>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue'
import {changeUserPassword} from '@/api/login'
export default {
  name: 'AvatarDropdown',
  props: {
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    }
  },
  data() {
    let checkPwd = ((rule, value, callback) => {
      if (value.trim().length < 6) {
        callback(new Error("请填写6位以上密码"));
      } else {
        callback();
      }
    })
    return {
      passwordPaneVisible: false,
      passwordValidate: {
        password: "",
        newPassword: ""
      },
      passwordRule: {
        password: [{
            required: true,
            message: '请输入原密码',
            trigger: 'blur'
          },
          {
            validator: checkPwd,
            trigger: 'blur'
          }
        ],
        newPassword: [{
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          },
          {
            validator: checkPwd,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    changeOperatorPassword() {
      this.$refs["passwordValidate"].validate((valid) => {
        if (valid) {
         changeUserPassword(JSON.parse(JSON.stringify(this.passwordValidate))).then(res => {
           if (res.code == 0) {
             this.$Message.success(res.msg)
             this.passwordPaneVisible = false;
           } else {
             this.$Message.error(res.msg)
           }
         })
        } else {
          this.$Message.error('未填写必填项！');
        }
      })
    
    },
    handleToCenter () {
      this.passwordValidate = {
        password: "",
        newPassword: ""
      };
      this.passwordPaneVisible = true;
     
    },
    handleToSettings () {
      this.$router.push({ path: '/account/settings' })
    },
    handleLogout (e) {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: this.$t('layouts.usermenu.dialog.content'),
        onOk: () => {
          // return new Promise((resolve, reject) => {
          //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1500)
          // }).catch(() => console.log('Oops errors!'))
          return this.$store.dispatch('Logout').then(() => {
            this.$router.push({ name: 'login' })
          })
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  :deep(.action) {
    margin-right: 8px;
  }
  :deep(.ant-dropdown-menu-item) {
    min-width: 160px;
  }
}
</style>
